import React from 'react';
import { useGlobalSearchContext } from '../../../../../context/GlobalSearchContext';

import { useSearchPanelContext } from '@context/SearchPanelContext';
import ListItem from '../ListItem';
import ListPanelProduct from '../ListPanelProduct';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { trackEvent } from '@monofront/tracking';
import PrismicLink from '@components/PrismicLink';

const SearchPanel = () => {
  const { isGlobalSearchResultsPanelOpen, setIsGlobalSearchResultsPanelOpen } =
    useGlobalSearchContext();
  const {
    searchPanel,
    displayCollections,
    displayBrands,
    hasMerchCard,
    products,
  } = useSearchPanelContext();

  const handleMerchCardClick = () => {
    trackEvent({
      type: 'LFSearchRecommendationClick',
      data: {
        recommendationType: 'merch_card',
        isSearchEmpty: true,
      },
    });
    setIsGlobalSearchResultsPanelOpen(false);
  };

  if (!searchPanel) return null;

  return (
    <>
      <div
        className={`limited-width-container ${
          isGlobalSearchResultsPanelOpen ? 'tw-grid' : 'tw-hidden'
        } tw-grid-cols-[282px,calc(100%-282px)] tw-justify-between tw-pt-8
        max-desktop:tw-grid-cols-1 max-desktop:tw-p-4`}
      >
        <div className="brands-and-collections tw-mb-8 tw-w-[282px] tw-pr-6 max-desktop:tw-mb-0">
          {displayCollections &&
            searchPanel.collections &&
            searchPanel.collections.length > 0 && (
              <div className="collections">
                <h2 className="hxm tw-mb-4">{searchPanel.collectionTitle}</h2>
                <div>
                  <ul className="tw-flex tw-flex-col">
                    {searchPanel.collections
                      .slice(0, 4)
                      .map((collection, index) => {
                        return (
                          <li key={index}>
                            <ListItem
                              onClick={() =>
                                trackEvent({
                                  type: 'LFSearchRecommendationClick',
                                  data: {
                                    recommendationType: 'collection',
                                    collectionName: collection.title,
                                    collectionSlug: `/collections/${collection.handle}`,
                                    isSearchEmpty: true,
                                  },
                                })
                              }
                              className="tw-lf-button tw-lf-button-secondary tw-lf-button-sm tw-mb-2 tw-inline-block"
                              item={collection}
                            />
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </div>
            )}
          {displayBrands &&
            searchPanel.brands &&
            searchPanel.brands.length > 0 && (
              <div
                className={`${
                  displayCollections ? 'tw-mt-6' : 'tw-mt-0'
                } tw-mb-6 md:tw-mb-0`}
              >
                <h2 className="hxm tw-mb-4">{searchPanel.brandTitle}</h2>
                <div>
                  <ul className="tw-flex tw-flex-col">
                    {searchPanel.brands.slice(0, 4).map((brand, index) => {
                      return (
                        <li key={index}>
                          <ListItem
                            onClick={() =>
                              trackEvent({
                                type: 'LFSearchRecommendationClick',
                                data: {
                                  recommendationType: 'brand',
                                  brandName: brand.title,
                                  brandSlug: `/collections/${brand.handle}`,
                                  isSearchEmpty: true,
                                },
                              })
                            }
                            className="tw-mb-2 tw-inline-block tw-cursor-pointer tw-rounded tw-p-1 tw-transition tw-duration-300 tw-ease-in-out hover:tw-bg-beige-200"
                            item={brand}
                          />
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            )}
        </div>
        <div
          className={`
          tw-mt-6 desktop:tw-mt-0
          ${
            hasMerchCard
              ? 'min-[1000px]:tw-flex min-[1000px]:tw-gap-x-4 min-[1400px]:tw-gap-x-10'
              : ''
          }
        `}
        >
          <div className={hasMerchCard ? `min-[1000px]:tw-w-[60%]` : ''}>
            <div className="tw-mb-4 tw-flex tw-flex-row tw-justify-between">
              <h2 className="hxm">
                {searchPanel.products!.length > 0 && searchPanel.productTitle}
              </h2>
            </div>
            {searchPanel.products!.length &&
              searchPanel.products!.length > 0 && (
                <ul
                  className={`tw-gap-2 tw-space-y-2 max-desktop:tw-mb-2 md:tw-grid md:-tw-space-y-0 ${
                    hasMerchCard ? '' : 'lg:tw-grid-cols-2'
                  }`}
                >
                  {products?.map((product) => {
                    return (
                      <ListPanelProduct key={product.id} product={product} />
                    );
                  })}
                </ul>
              )}
          </div>
          {hasMerchCard && (
            <div
              onClick={handleMerchCardClick}
              className="tw-relative tw-mx-auto tw-mt-5 tw-h-[444px] tw-w-full tw-cursor-pointer tw-justify-self-end phone-l:tw-max-w-[340px] min-[1000px]:tw-m-0 min-[1000px]:tw-w-[45%] lg:tw-mx-0 min-[1100px]:tw-w-[50%]"
            >
              <PrismicLink link={searchPanel.merch!.merchLink}>
                <ResponsiveImage
                  objectFit="cover"
                  layout="fill"
                  className="tw-rounded-lg"
                  alt={searchPanel.merch!.merchImage.alt}
                  src={searchPanel.merch!.merchImage.url}
                />
              </PrismicLink>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SearchPanel;
